import Paper from "@material-ui/core/esm/Paper";
import React from 'react';
import { PrimaryButton, SecondaryButton } from 'components/Button';
import { Title } from 'components/Text';
import useStyles from './SummaryPageStyles';
export default function SummaryPageAd({
  image,
  title,
  text,
  primaryButton,
  secondaryButton
}) {
  const {
    ad,
    adText,
    adButtons,
    adTextContainer
  } = useStyles();
  return /*#__PURE__*/React.createElement(Paper, {
    className: ad
  }, /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: title
  }), /*#__PURE__*/React.createElement("div", {
    className: adTextContainer
  }, /*#__PURE__*/React.createElement(Title, null, title), /*#__PURE__*/React.createElement("div", {
    className: adText
  }, text), /*#__PURE__*/React.createElement("div", {
    className: adButtons
  }, /*#__PURE__*/React.createElement("a", {
    href: primaryButton.link,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(PrimaryButton, null, primaryButton.text)), secondaryButton && /*#__PURE__*/React.createElement("a", {
    href: secondaryButton.link,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(SecondaryButton, null, secondaryButton.text)))));
}
SummaryPageAd.defaultProps = {
  secondaryButton: null
};